App.AuthRestoreRoute = Ember.Route.extend
  session: Em.inject.service()
  controllerName: 'auth.login'
  templateName: 'auth.login'

  setupController: (controller, model) ->
    controller.set('loginValue', '')
    controller.set('restoringPassword', true)
    controller.set('passwordValue', '')
